import { ListItem } from 'tamagui';

export default ListItem;
